import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { ShareEpisodeModalContent } from './ShareEpisodeModalContent';

export const ShareEpisodeModal = () => {
  return (
    <AppModal
      modalName={Modals.SHARE_EPISODE}
      maxWidth={false}
      scroll="paper"
      transparentBackground>
      <ShareEpisodeModalContent />
    </AppModal>
  );
};
